'use strict';

/**
 * The environment every classifier reads when it is handed none (ECOSYSTEM-EMAIL-001 DEV-TIER-RULE).
 *
 * Under Node it is `process.env`. In a BROWSER bundle there is no `process` (Vite's `define` replaces only the literal
 * `process.env.NODE_ENV`), so a bare `process.env` default would throw `ReferenceError: process is not defined` the
 * moment a browser caller relied on it. There it is an EMPTY environment: no tier is declared, so every classifier
 * answers fail-closed — a browser that declares nothing is DEPLOYED, never local development.
 *
 * @module @puffin-core/env/processEnv
 */

/** No declared environment: frozen, so a consumer can never write a tier into it. */
const NO_ENV = Object.freeze({});

/**
 * @param {Object} [scope=globalThis] - the global scope to read (`globalThis`; a test hands it one with no `process`)
 * @returns {NodeJS.ProcessEnv|Readonly<Object>} `process.env`, or an empty environment where there is no process
 */
function processEnv(scope = globalThis) {
  return scope.process === undefined ? NO_ENV : scope.process.env;
}

module.exports = { processEnv, NO_ENV };
